<div [class.rem-fix]="fixRem"
     class="layout">

  <div class="item">
    <pop-estimate-budget-type [(estimateBudgetTypes)]="estimateBudgetTypes"
                              [estimateBudgetType]="EstimateBudgetTypesEnum.Global"
                              [disabled]="disabled"
                              [(consentGranted)]="consentGranted"></pop-estimate-budget-type>
  </div>
  <div class="summary">
    <ng-container *ngFor="let budgetTypeItem of budgetTypeItems">
      <pop-estimate-budget-type [(estimateBudgetTypes)]="estimateBudgetTypes"
                                [estimateBudgetType]="budgetTypeItem"
                                [disabled]="!isDetailed || disabled"
                                [(consentGranted)]="consentGranted"></pop-estimate-budget-type>

    </ng-container>
  </div>



</div>
